/// <summary>
/// Objects statuses
/// </summary>
export enum ObjectStatus
{
  Blocked = 0,
  Active = 1,
  Broken = 10,
  OnService = 11,
  NotInstalled = 15,
  Deleted = 255
}
